import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { fetchSourceTableAndFilterSchema } from "model/SourceModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";


const SourceContext = createContext();

export const SourceProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [sourceContextData, setSouceContextData] = useState();

  const fetchSourceContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:source", () =>
        fetchSourceTableAndFilterSchema([])
      );
      if (response?.success) {
        setSouceContextData(response?.data);
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };



    // 🔹 Fetch home page data once

    useEffect(() => {
        const fetchAll = async () => {
            await Promise.all([]);
        };
        fetchAll();
    }, []);

    return (
        <SourceContext.Provider value={{ fetchSourceContextData, sourceContextData, loading, error }}>
            {children}
        </SourceContext.Provider>
    );
};

export const useSourceContext = () => useContext(SourceContext);
